import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import EtablissementCard from "../EtablissementCard/EtablissementCard";
import { Etablissement } from "../../schemas/etablissement/etablissemen.schema";
import { PartialEtablissement } from "../../api/types/types";

import styles from "./EtablissementList.module.scss";
import PaginationFooter from "../PaginationFooter/PaginationFooter";
import { noResults } from "../../assets/svgs/pictures/no-result.svg";

type Props = {
  etablissements: (Etablissement | PartialEtablissement)[];
  setIsAddCollaborateurPopupOpen:React.Dispatch<React.SetStateAction<boolean>>
  ville : string,
};

export default function EtablissementList(props: Props) {
  const { etablissements,setIsAddCollaborateurPopupOpen,ville } = props;
  const { t } = useTranslation();

  return (
    <article className={styles.etablissementList}>
      <header className={styles.etablissementList__header}>
        <p>
          {t('establishmentSearch.selectDay')} {ville && ville + " am nächsten liegt"}.
        </p>
        <p>
          <strong>{t('inscriptionPage.warning')}</strong> {t('establishmentSearch.travelExpensesWarning')}
        </p>
      </header>
      <main className={styles.etablissementList__main}>
        {etablissements.length !== 0 ? (
          etablissements.map((etablissement: Etablissement | PartialEtablissement, index: number) => (
            <Fragment key={"etablissementList_" + index + etablissement.name}>
              <EtablissementCard 
                setIsAddCollaborateurPopupOpen={setIsAddCollaborateurPopupOpen}
                etablissement={etablissement as PartialEtablissement} />
            </Fragment>
          ))
        ) : (
          <>
            <h1>{t('error.errorMessage.noResult')}</h1>
            {noResults}
          </>
        )}
      </main>
    </article>
  );
}